import { Navigate } from "react-router-dom";
import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../global/config/store";

type Props = {
  children: ReactNode;
};

const PrivateRoute = ({ children }: Props) => {
  const { token, isLoggedIn } = useSelector((state: RootState) => state.auth);
  
  if (!isLoggedIn || !token) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
